export const LOGO_URL = "https://customer-assets.emergentagent.com/job_property-hub-1124/artifacts/0v322ds4_LOGO%20URBAN%20DREAMS%20HOME.png";
export const BRAND_CREAM = "#F7F2EA";
export const BRAND_NAVY = "#1B3A5B";
